import React, { useState, Fragment } from 'react';
import { Backdrop, Button, CircularProgress, useTheme, Typography, TextField, Grid, Avatar, Box } from '@mui/material';
import { useAsync } from '../utils/hooks'
import Autocomplete from '@mui/material/Autocomplete';
import apiRequest from '../functions/api';
import { useSessionStorage } from '../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../constants/localStorage';
import { useMessage } from '../context/message-context';
import { useTranslation } from 'react-i18next';
const DateTextField = (props) => {
  return (
    <TextField
      {...props}
      type="date"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        ...props.inputProps,
        max: "2099-12-31",
      }}
    >
      {props.children}
    </TextField>
  )
}

const TimeTextField = (props) => {
  return (
    <TextField
      {...props}
      type="time"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        ...props.inputProps,
        max: "24:00",
      }}
    >
      {props.children}
    </TextField>
  )
}
const DateTimeTextField = (props) => {
  return (
    <TextField
      {...props}
      type="datetime-local"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        ...props.inputProps,
        max: "24:00",
      }}
    >
      {props.children}
    </TextField>
  )
}

const FullPageSpinner = ({ message }) => {
  const theme = useTheme();
  return (
    <Backdrop open style={{ color: theme.palette.common.white, zIndex: theme.zIndex.modal + 1 }}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} >
          <CircularProgress color="inherit" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{message}</Typography>
        </Grid>
      </Grid>
    </Backdrop>
  )
}
const SearchTextField = (props) => {
  return (
    <TextField
      {...props}
      onKeyPress={(e) => {
        if (e.key === 'Enter') { e.preventDefault(); }
      }}
    />
  )
}
const FullPageErrorFallback = (props) => {
  const theme = useTheme();
  return (
    <Backdrop open style={{ color: theme.palette.common.white, zIndex: theme.zIndex.drawer + 1 }}>
      <Typography variant="body1">{props.error.message}</Typography>
    </Backdrop>
  )
}
const AsyncButton = (props) => {
  const { isLoading, run } = useAsync();
  function onButtonClick() {
    run(props.asyncFunction());
  }
  return (
    <Button
      onClick={() => onButtonClick()}
      {...props}
      endIcon={isLoading && <CircularProgress color="inherit" />}
      disabled={isLoading}
    >
      {props.children}
    </Button>
  )
}
const Mitarbeiterauswahl = (props) => {
  const { programm, client, austritt } = props;
  const [mitarbeiter, setMItarbeiter] = useState([]);
  const [antwort, setAntwort] = useState(null);
  const [issending, setIsSending] = useState(false);
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage } = useMessage();
  const {t} = useTranslation();
  const pruefe_an = (value) => {
    setIsSending(true)
    const payload = {
      "mandant": client,
      "program": programm,
      "mitarbeiter": value,
      "austritt": austritt,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'mitarbeiter', payload, headers, anCb);
  }
  const anCb = (response) => {
    setIsSending(false)
    if (response.status === 200) {
      if (response.data.mitarbeiter) {
        setMItarbeiter(response.data.mitarbeiter)
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  return (
    <Grid item xs={12}>
      <Autocomplete
        noOptionsText={mitarbeiter.length > 0 ? t("Kein Eintrag gefunden") : t("Suchen Sie nach dem Namen oder der Personalnummer")}
        value={antwort}
        onChange={(event, newValue) => {
          setAntwort(newValue);
          if (newValue) {
            props.onChange(newValue.key);
          } else {
            props.onChange('');
          }
        }}
        loading={issending}
        onInputChange={
          (event, newValue) => {
            pruefe_an(newValue)
          }
        }
        options={mitarbeiter}
        getOptionLabel={(option) => option?.anzeige || ''}
        renderInput={(params) =>
          <TextField
            autoFocus
            {...params}
            label={props.label}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {issending ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />}
      />
    </Grid>
  )
}
const Zeitraum = (props) => {
  const { antw } = props;
  const [antwort, setAntwort] = useState(antw);
  return (
    <Grid item xs={12}>
      <TextField
        type="month"
        variant="outlined"
        fullWidth
        autoFocus={(window.cordova) ? false : true}
        value={antwort}
        onBlur={(event) => { if (event.relatedTarget === null) { props.onBlur(antwort) } }}
        onKeyDown={
          (taste) =>
            taste.key === "Enter" &&
            taste.target.blur()
        }
        onChange={(event) => {
          if (window.cordova) {
            props.onChange(event.target.value)
          } else {
            setAntwort(event.target.value)
          }
        }
        }
        InputLabelProps={{
          shrink: true,
        }}
      >
      </TextField>
    </Grid>
  )
}

const getMonthName = (month) => {
  switch (month) {
    case 0:
      return "Januar"
    case 1:
      return "Februar"
    case 2:
      return "März"
    case 3:
      return "April"
    case 4:
      return "Mai"
    case 5:
      return "Juni"
    case 6:
      return "Juli"
    case 7:
      return "August"
    case 8:
      return "September"
    case 9:
      return "Oktober"
    case 10:
      return "November"
    case 11:
      return "Dezember"
    default:
      return "";
  }
};

const FileUploadComponent = ({ multiple, color, id, variant, onChange, children }) => {
  // // if (window.cordova) {
  //   const handleClick = (event) => {
  //     const cameraSuccess = (imageUrl) => {
  //       onChange(imageUrl)
  //     }
  //     const cameraError = () => {
  //       console.log("cameraError occured")
  //     }
  //     const cameraOptions = {
  //       destinationType: "FILE_URI",
  //     }
  //     navigator.camera.getpicture(cameraSuccess, cameraError, cameraOptions);
  //   // }
  //   return (
  //     <Button
  //       id={id}
  //       variant={variant}
  //       color={color}
  //       onClick={handleClick}
  //     >
  //       {children}
  //     </Button>
  //   )
  // } else {
  const onChangeHandler = (event) => {
    if (multiple) {
      return (onChange(event.target.files))
    } else {
      return (onChange(event.target.files[0]))
    }
  }
  return (
    <>
      <input
        multiple={multiple}
        color={color}
        type="file"
        id={id}
        onChange={onChangeHandler}
        style={{ display: 'none' }}
      />
      <label htmlFor={id} className="mr-2">
        <Button
          id={id}
          variant={variant}
          component="span"
          color={color}
          fullWidth
        >
          {children}
        </Button>
      </label>
 
    </>
  )
}
// }
function istInteger(string) {  
  return /^\d+$/.test(string) || /^$/.test(string);
}
function prec(n) {  
  if (!isFinite(n)) return 0;
  var e = 1, p = 0;
  while (Math.round(n * e) / e !== n) { e *= 10; p++ }
  return p;
}
export {
  FullPageSpinner,
  FullPageErrorFallback,
  AsyncButton,
  istInteger,
  Mitarbeiterauswahl,
  Zeitraum,
  DateTextField,
  TimeTextField,
  DateTimeTextField,
  SearchTextField,
  prec,
  FileUploadComponent,
  getMonthName
}
